import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Button,
  Box,
  Link,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FormatNumber } from "../../../utils/formatNumber";
import { useState } from "react";
import ViewPriceList from "./ViewPriceList";

const PreIpoList = ({ list, token }) => {
  const navigate = useNavigate();
  const [isPriceSlabOpen, setIsPriceSlabOpen] = useState<boolean>(false);
  const [modelData, setModelData] = useState<any>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    // <TableContainer component={Paper}>
    <>
      <Grid
        container
        spacing={2}
        sx={{
          padding: "20px",
        }}
      >
        {list?.map((row: any) => {
          return (
            <Grid item xs={12} sm={6} lg={4} xl={3} key={row.isin}>
              <Card
                sx={{
                  height: "auto",
                  boxShadow: 3,
                  borderRadius: 2,
                  backgroundColor: "#f9fafb",
                  position: "relative",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  m: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: 6,
                  },
                }}
              >
                <Box sx={{ p: 2, display: "flex", alignItems: "center" }}>
                  <Box sx={{ mr: 2 }}>
                    <CardMedia
                      component="img"
                      image={row?.company.logo_url}
                      alt="Logo"
                      sx={{
                        width: 60,
                        height: 60,
                        borderRadius: "10px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, overflow: "hidden" }}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%"
                      }}
                    >
                      {row.company.display_name}
                    </Typography>
                    {row.company?.sector && (
                      <Typography
                        variant="caption"
                        sx={{
                          backgroundColor: "#E3F2FD",
                          padding: "4px 8px",
                          borderRadius: 1,
                          display: "inline-block",
                          mt: 0.5
                        }}
                      >
                        {row.company.sector}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Divider />
                <CardContent sx={{ p: 2, pb: 10 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mb: 2,
                      display: "-webkit-box",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 3,
                    }}
                  >
                    {row.company.description}
                  </Typography>
                  <Box sx={{ display: "flex", mb: 1 }}>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2" fontWeight="bold">
                        Price per share:
                      </Typography>
                    </Box>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2" fontWeight="bold">
                        Sales
                      </Typography>

                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", mb: 2 }}>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2">
                        {FormatNumber(row.price.price) ?? "N/A"}
                      </Typography>
                    </Box>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2">
                        {row.distribution.sales ?? "N/A"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", mb: 1 }}>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2" fontWeight="bold">
                        Minimum Units
                      </Typography>
                    </Box>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2" fontWeight="bold">
                        Maximum Units
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", mb: 2 }}>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2">
                        {FormatNumber(row.min_units)}
                      </Typography>
                    </Box>
                    <Box sx={{ width: "50%" }}>
                      <Typography variant="body2">
                        {FormatNumber(row.max_units)}
                      </Typography>
                    </Box>
                  </Box>


                  {/* <Link
                    href="#"
                    variant="body2"
                    sx={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginTop: 3,
                    }}
                  >
                    Read: How {row.company.display_name} profitable!
                  </Link> */}
                </CardContent>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    gap: "10px",
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      borderRadius: "5px",
                      textAlign: "center",
                      border: "1px solid #ffa500",
                      color: "#ffa500",
                      background: "#ffffff",
                      fontWeight: "bold",
                      textTransform: "none",
                      '&:hover': {
                        background: "#ffa500",
                        color: "white",
                        borderColor: "#ffa500"
                      },
                    }}
                    onClick={(e) => {
                      setModelData({
                        date: row.price.trade_date,
                        isin: row.isin,
                        price: row?.price?.price,
                      });
                      setIsPriceSlabOpen(true);
                    }}
                  >
                    Grab Discount
                  </Button>
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      borderRadius: "5px",
                      textAlign: "center",
                      border: "1px solid #1976D2",
                      color: "#1976D2",
                      background: "#ffffff",
                      fontWeight: "bold",
                      textTransform: "none",
                      '&:hover': {
                        background: "#1976D2",
                        color: "white",
                        borderColor: "#1976D2"
                      },
                    }}
                    onClick={(e) =>
                      navigate(`/dashboardAdmin/pre-ipo-explore/${row.isin}`, {
                        state: { value: row },
                      })
                    }
                  >
                    View Details
                  </Button>
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      {isPriceSlabOpen && (
        <ViewPriceList
          isPriceSlabOpen={isPriceSlabOpen}
          setIsPriceSlabOpen={setIsPriceSlabOpen}
          price={modelData.price}
          token={token}
          date={modelData.date}
          isin={modelData.isin}
        />
      )}
    </>

    // </TableContainer>
  );
};

export default PreIpoList;
